/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  function stripZeros(str) {
    return str
      .replace(/([.,])00(\s|$)/, '$2')
      .replace(/([.,]\d)0(\s|$)/, '$1$2');
  }

  // Ensure window.theme exists early
  window.theme = window.theme || {};

  // If formatMoney isn't defined yet, hook the setter so that when theme.js assigns it,
  // we immediately wrap it to strip trailing zeros.
  if (!('formatMoney' in window.theme)) {
    Object.defineProperty(window.theme, 'formatMoney', {
      configurable: true,
      enumerable: true,
      set: function(fn) {
        var wrapped = function(cents, format) {
          var out = fn.call(this, cents, format);
          return stripZeros(out);
        };
        Object.defineProperty(window.theme, 'formatMoney', {
          value: wrapped,
          writable: true,
          configurable: true,
          enumerable: true
        });
      },
    });
  }

  // If theme.js loaded before this script for some reason, patch directly.
  if (typeof window.theme.formatMoney === 'function') {
    var original = window.theme.formatMoney;
    window.theme.formatMoney = function(cents, format) {
      return stripZeros(original.call(this, cents, format));
    };
  }

  // After the document is ready, scrub any prices already rendered
  document.addEventListener('DOMContentLoaded', function () {
    var selectors = [
      '[data-product-price]',
      '[data-compare-price]',
      '[data-product-unit-price]',
      '[data-price-off-amount]',
      '[data-cart-price]',
      '.money'
    ].join(', ');

    document.querySelectorAll(selectors).forEach(function (el) {
      el.innerHTML = stripZeros(el.innerHTML);
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
